<template>
  <div class="logo">
    <div class="container container-flex">
      <div class="logo_news" @click="click_GA">
        <a href="https://udn.com/news/index" target="_blank"><img :src="require('../general_images/udn_logo.svg')"></a>
      </div>
      <div class="logo_newmedia">
        <img :src="require('../general_images/newmedia_logo.png')">
      </div>
    </div>
  </div>
</template>

<script>
import Utils from 'udn-newmedia-utils'

export default {
  name: 'Logo',
  props: {
    href: String
  },
  data() {
    return {
    }
  },
  methods: {
    click_GA() {
      window.ga('newmedia.send', 'event', {
        eventCategory: 'logo',
        eventAction: 'click',
        eventLabel: `[${Utils.detectPlatform()}][${document.querySelector('title').innerHTML}][921_新聞網]`
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.logo {
  width: 100%;
  margin-left: -6px;
  margin-top: 140px;
  margin-bottom: 30px;
  @media (min-width: 768px) and (max-width: 1279.98px) {
    margin-top: 185px;
  }
  @media (min-width: 1280px) {
    margin-top: 185px;
  }
}
.container-flex {
  display: flex;
}
.logo_news, .logo_newmedia {
  padding-right: 8px;
  img {
    max-width: 132px;
  }
}
</style>
